//src\Redux\store.ts
import { configureStore } from "@reduxjs/toolkit";
import dashboardSlice from "./DashboardSlice";
import accountSlice from "./AccountSlice";
import feeAuditorsSlice from "./FeeAuditorsSlice";
import TiersSlice from "./TiersSlice";
import GeneralSlice from "./GeneralSlice";
import caseSlice from "./CaseSlice";
import UserSlice from "./UserSlice";
import appStateSlice from "./AppStateSlice";
import packingListSlice from "./packingListSlice"; 
import languageReducer from './LanguageSlice';
import partnerReducer from './PartnerSlice';

const isDevelopment = process.env.NODE_ENV === "development";

export const store = configureStore({
  reducer: {
    case: caseSlice,
    dashboard: dashboardSlice,
    account: accountSlice,
    feeAuditors: feeAuditorsSlice,
    tiers: TiersSlice,
    general: GeneralSlice,
    user: UserSlice,
    packingList: packingListSlice,
    appState: appStateSlice,
    language: languageReducer,
    partner: partnerReducer,
  },
  devTools: isDevelopment
    ? { trace: true, traceLimit: 25 }
    : false, 
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;